import React from 'react';
import Translate from 'react-translate-component';

import { CompanyLink, Counter, TextLine, ItemsList, Money } from 'components/common/tableComponents/cellTemplates';
import WorksheetLink from './WorksheetLink';
import ProjectSidebarLink from './ProjectSidebarLink';
import Classifiers from 'components/common/tableComponents/cellTemplates/Classifiers';

const Group = ({ value }) => (
    <span>
        <Translate content="status" />: {value}
    </span>
);

const ProjectTableTemplates = {
    salary:        Money,
    feeperpos:     Money,
    amountmin:     Money,
    amountmax:     Money,
    group:         Group,
    details:       ProjectSidebarLink,
    number:        Counter,
    posname:       WorksheetLink,
    classifier:    Classifiers,
    approval:      ItemsList,
    candidates:    ItemsList,
    company:       CompanyLink,
    documents:     ItemsList,
    emplofra:      ItemsList,
    participants:  ItemsList,
    workcommit:    ItemsList,
    responsible:   ItemsList,
    result:        ItemsList,
    negwithclient: ItemsList,
    clientcontactpers: ItemsList,
    ParticipantsWithRole: ItemsList,
};

export default function getProjectTableTemplate(columnName) {
    return ProjectTableTemplates[columnName] || TextLine;
}
